import React from 'react'
import Banner from './banner';
import FeatureNew from './feature-new';
import Slide1 from './slide1';
import Slide3 from './slide3';
import Slide4 from './slide4';
import Technologygcc from './technologygcc';
import Cutttingedge from "./cutttingedge";
import Servicesweb from './servicesweb';
import Topgradecta from './topgradecta';
import Slide5 from './slide5';
import Slide6 from './slide6';
import Techstacklp from './techstacklp';
import Workflow from "./workflow";
import Associatesslider from "./associatesslider";
import EbookLanding from './ebook';
import FooterLanding from './footer';
import Sidebtns from './sidebtns';

const Slidersmobile = () => {
  return (
    <div className="main_lp_web_sec">
       <Banner/>
       <FeatureNew/>
       <Slide1/>
       <Slide3/>
       <Slide4/>
       <Technologygcc/>
       <Cutttingedge />
       <Servicesweb />
       <Topgradecta />
       <Slide5/>
       <Slide6/>
       <Techstacklp/>
       <Workflow />
       <Associatesslider />
       <EbookLanding />
       <FooterLanding />
       
       <Sidebtns/>
    </div>
  )
}

export default Slidersmobile